import { useState, useEffect } from 'react';

/**
 * Hook responsive mejorado según las mejores prácticas de Tekla.io
 * Implementa Mobile First y breakpoints inteligentes
 */
export const useResponsive = () => {
  const [screenInfo, setScreenInfo] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0,
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    isLandscape: false,
    isPortrait: false,
    pixelRatio: typeof window !== 'undefined' ? window.devicePixelRatio : 1,
    orientation: typeof window !== 'undefined' ? window.screen.orientation?.type || 'portrait' : 'portrait'
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const pixelRatio = window.devicePixelRatio;
      const orientation = window.screen.orientation?.type || 'portrait';

      // Breakpoints según Tekla.io - Mobile First
      const isMobile = width < 768;        // < 768px
      const isTablet = width >= 768 && width < 1024;  // 768px - 1023px
      const isDesktop = width >= 1024;     // >= 1024px
      const isLandscape = orientation === 'landscape';
      const isPortrait = orientation === 'portrait';

      setScreenInfo({
        width,
        height,
        isMobile,
        isTablet,
        isDesktop,
        isLandscape,
        isPortrait,
        pixelRatio,
        orientation
      });
    };

    // Ejecutar una vez al montar
    handleResize();

    // Agregar event listeners
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  // Utilidades adicionales según Tekla.io
  const getResponsiveClass = (mobileClass, tabletClass, desktopClass) => {
    if (screenInfo.isMobile) return mobileClass;
    if (screenInfo.isTablet) return tabletClass;
    return desktopClass;
  };

  const getResponsiveValue = (mobileValue, tabletValue, desktopValue) => {
    if (screenInfo.isMobile) return mobileValue;
    if (screenInfo.isTablet) return tabletValue;
    return desktopValue;
  };

  // Detectar dispositivos táctiles
  const isTouchDevice = () => {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  };

  // Detectar dispositivos de alta densidad
  const isHighDPI = () => {
    return screenInfo.pixelRatio > 1;
  };

  // Detectar preferencias de movimiento reducido
  const prefersReducedMotion = () => {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  return {
    ...screenInfo,
    getResponsiveClass,
    getResponsiveValue,
    isTouchDevice: isTouchDevice(),
    isHighDPI: isHighDPI(),
    prefersReducedMotion: prefersReducedMotion()
  };
};
